import { makeScopedSettings } from './makeScopedSettings';
import { CoherenceV9LightTheme } from '@coherence-design-system/styles';
/** Generator for the MSRC official light theme */
export const msrcLightCustomizations = () => {
    const lightTheme = CoherenceV9LightTheme;
    lightTheme.components = makeScopedSettings(CoherenceV9LightTheme);
    return lightTheme;
};
